document.addEventListener('DOMContentLoaded', function() {
  function hideEmptyParagraphs() {
    const paragraphs = document.querySelectorAll('p');
    
    paragraphs.forEach(p => {
      const textContent = p.textContent.trim();
      
      if (textContent === '' || textContent.length === 0) {
        p.style.display = 'none';
      }
    });
  }
  hideEmptyParagraphs();
});


function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

function initProductTabs() {
  const descriptions = document.querySelectorAll('.product__description:not(.tabs-initialized)');
  
  descriptions.forEach(desc => {
    const hasMetafieldTabs = desc.querySelector('.has-metafield-tabs');
    
    if (hasMetafieldTabs) {
      // Nouveau système avec metafields
      initMetafieldTabs(desc);
    } else {
      // Ancien système basé sur les <strong>
      initLegacyTabs(desc);
    }
  });
}

function initMetafieldTabs(desc) {
  const hasMetafieldTabs = desc.querySelector('.has-metafield-tabs');
  hasMetafieldTabs.remove();
  
  // Récupérer les metafields tabs
  const metafieldTabs = desc.querySelectorAll('.metafield-tab');
  const metafieldData = [];
  metafieldTabs.forEach(tab => {
    metafieldData.push({
      title: tab.getAttribute('data-tab-title'),
      content: tab.innerHTML
    });
    tab.remove();
  });
  
  // Nettoyer les paragraphes vides
  cleanEmptyParagraphs(desc);
  
  // Créer les conteneurs
  const tabsContainer = document.createElement('div');
  tabsContainer.className = 'tabs-container';
  
  const tabsNav = document.createElement('div');
  tabsNav.className = 'tabs-nav';
  
  const tabsContent = document.createElement('div');
  tabsContent.className = 'tabs-content';
  
  // Récupérer tout le contenu restant pour l'onglet Description
  const remainingContent = Array.from(desc.children).map(el => el.cloneNode(true));
  
  if (remainingContent.length > 0) {
    const descTabButton = document.createElement('div');
    descTabButton.className = 'sect-par link-hover-line act';
    descTabButton.setAttribute('data-tar', 'description');
    const descStrongTitle = document.createElement('strong');
    descStrongTitle.textContent = 'Description';
    descTabButton.appendChild(descStrongTitle);
    tabsNav.appendChild(descTabButton);
    
    const descSectWrap = document.createElement('div');
    descSectWrap.className = 'sect-wrap act';
    descSectWrap.setAttribute('data-id', 'description');
    remainingContent.forEach(el => {
      descSectWrap.appendChild(el);
    });
    tabsContent.appendChild(descSectWrap);
  }
  
  // Ajouter les onglets metafields
  metafieldData.forEach(data => {
    const tabButton = document.createElement('div');
    tabButton.className = 'sect-par link-hover-line';
    tabButton.setAttribute('data-tar', slugify(data.title));
    const strongTitle = document.createElement('strong');
    strongTitle.textContent = data.title;
    tabButton.appendChild(strongTitle);
    tabsNav.appendChild(tabButton);
    
    const sectWrap = document.createElement('div');
    sectWrap.className = 'sect-wrap';
    sectWrap.setAttribute('data-id', slugify(data.title));
    sectWrap.innerHTML = data.content;
    tabsContent.appendChild(sectWrap);
  });
  
  // Vider et reconstruire
  desc.innerHTML = '';
  
  if (tabsNav.children.length > 0) {
    tabsContainer.appendChild(tabsNav);
    tabsContainer.appendChild(tabsContent);
    desc.appendChild(tabsContainer);
  }
  
  desc.classList.add('tabs-initialized');
  bindTabClicks(desc);
}

function initLegacyTabs(desc) {
  // Nettoyer les paragraphes vides
  cleanEmptyParagraphs(desc);
  
  // Créer les conteneurs
  const tabsContainer = document.createElement('div');
  tabsContainer.className = 'tabs-container';
  
  const tabsNav = document.createElement('div');
  tabsNav.className = 'tabs-nav';
  
  const tabsContent = document.createElement('div');
  tabsContent.className = 'tabs-content';
  
  let firstContent = true;
  let currentElements = [];
  const children = Array.from(desc.children);
  
  children.forEach((elem, index) => {
    const strongElem = elem.querySelector('strong');
    
    if (strongElem && strongElem.textContent.trim()) {
      if (firstContent && currentElements.length > 0) {
        // Créer l'onglet Description
        const descTabButton = document.createElement('div');
        descTabButton.className = 'sect-par link-hover-line act';
        descTabButton.setAttribute('data-tar', 'description');
        const descStrongTitle = document.createElement('strong');
        descStrongTitle.textContent = 'Description';
        descTabButton.appendChild(descStrongTitle);
        tabsNav.appendChild(descTabButton);
        
        const descSectWrap = document.createElement('div');
        descSectWrap.className = 'sect-wrap act';
        descSectWrap.setAttribute('data-id', 'description');
        currentElements.forEach(el => {
          descSectWrap.appendChild(el);
        });
        tabsContent.appendChild(descSectWrap);
        
        currentElements = [];
        firstContent = false;
      }
      
      const title = strongElem.textContent.trim();
      const id = slugify(title);
      
      const tabButton = document.createElement('div');
      tabButton.className = 'sect-par link-hover-line';
      tabButton.setAttribute('data-tar', id);
      const strongTitle = document.createElement('strong');
      strongTitle.textContent = title;
      tabButton.appendChild(strongTitle);
      tabsNav.appendChild(tabButton);
      
      const sectWrap = document.createElement('div');
      sectWrap.className = 'sect-wrap';
      sectWrap.setAttribute('data-id', id);
      
      let nextIndex = index + 1;
      while (nextIndex < children.length) {
        const nextElem = children[nextIndex];
        const nextStrong = nextElem.querySelector('strong');
        
        if (nextStrong && nextStrong.textContent.trim()) {
          break;
        }
        
        sectWrap.appendChild(nextElem.cloneNode(true));
        nextIndex++;
      }
      
      tabsContent.appendChild(sectWrap);
      
    } else if (firstContent) {
      currentElements.push(elem.cloneNode(true));
    }
  });
  
  // Si pas d'onglets trouvés mais du contenu, créer l'onglet Description
  if (tabsNav.children.length === 0 && currentElements.length > 0) {
    const descTabButton = document.createElement('div');
    descTabButton.className = 'sect-par link-hover-line act';
    descTabButton.setAttribute('data-tar', 'description');
    const descStrongTitle = document.createElement('strong');
    descStrongTitle.textContent = 'Description';
    descTabButton.appendChild(descStrongTitle);
    tabsNav.appendChild(descTabButton);
    
    const descSectWrap = document.createElement('div');
    descSectWrap.className = 'sect-wrap act';
    descSectWrap.setAttribute('data-id', 'description');
    currentElements.forEach(el => {
      descSectWrap.appendChild(el);
    });
    tabsContent.appendChild(descSectWrap);
  }
  
  // Vider et reconstruire
  desc.innerHTML = '';
  
  if (tabsNav.children.length > 0) {
    tabsContainer.appendChild(tabsNav);
    tabsContainer.appendChild(tabsContent);
    desc.appendChild(tabsContainer);
  }
  
  desc.classList.add('tabs-initialized');
  bindTabClicks(desc);
}

function cleanEmptyParagraphs(container) {
  const paragraphs = container.querySelectorAll('p, strong');
  paragraphs.forEach(p => {
    if (!p.textContent.trim() || p.innerHTML === '<br>') {
      p.remove();
    }
  });
}

function bindTabClicks(container) {
  const tabs = container.querySelectorAll('.sect-par');
  
  tabs.forEach(tab => {
    tab.replaceWith(tab.cloneNode(true));
  });
  
  const newTabs = container.querySelectorAll('.sect-par');
  
  newTabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      const id = this.getAttribute('data-tar');
      const parent = this.closest('.product__description');
      
      if (this.classList.contains('act')) {
        parent.querySelectorAll('.sect-par.act').forEach(el => el.classList.remove('act'));
        parent.querySelectorAll('.sect-wrap.act').forEach(el => el.classList.remove('act'));
      } else {
        parent.querySelectorAll('.sect-par.act').forEach(el => el.classList.remove('act'));
        parent.querySelectorAll('.sect-wrap.act').forEach(el => el.classList.remove('act'));
        
        this.classList.add('act');
        const content = parent.querySelector(`.sect-wrap[data-id="${id}"]`);
        if (content) content.classList.add('act');
      }
    });
  });
}

// Initialiser au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
  initProductTabs();
});

// Pour Shopify, réinitialiser lors des changements de variantes
document.addEventListener('variant:changed', function() {
  setTimeout(function() {
    initProductTabs();
  }, 100);
});

// Alternative pour Shopify si l'événement variant:changed n'existe pas
if (typeof Shopify !== 'undefined') {
  // Observer les changements dans le DOM pour les mises à jour de variantes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const hasDescriptionChange = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && 
                 (node.classList?.contains('product__description') || 
                  node.querySelector?.('.product__description'));
        });
        
        if (hasDescriptionChange) {
          setTimeout(initProductTabs, 100);
        }
      }
    });
  });
  
  // Observer le body pour les changements
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}